import { Globals as OldGlobals } from '../../global/Globals';
import Button from '../../components/Button/Button';
import './Sample.css';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import { useLanguage } from '../../context/Languagecontext';

const Signup = () => {
  const { Globals } = useLanguage();
  const navigate = useNavigate();
  const navigateBack = () => {
    navigate(Globals.NAVPATH.ROOT);
  }
  const navigateToProducerRegistration = () => {
    navigate(Globals.NAVPATH.PRODUCER_SIGNUP);
  }

  const navigateToCompanyRegistration = () => {
    navigate(Globals.NAVPATH.COMPANY_SIGNUP);
  }
  return (
    <>
      <div className="backgroundSpace">
        <div className="header" onClick={navigateBack}>
          <div className="arrowLeftLineWrapper">
            <img className="arrowLeftLineIcon" src={Globals.IMG.LEFT_ARROW} alt="arrow-left-line" />
          </div>
        </div>
        <div className="frameParent">
          <div className="frameGroup">
            <div className="registerAsACompanyParent company-description">
              <div className="registerAsA">{Globals.SIGNUP.COMPANY}</div>
              <div className="thisOptionIs">
                <p className="description">{Globals.SIGNUP.COMPANY_DESC_LINE1}</p><br/>
                <p className="description">{Globals.SIGNUP.COMPANY_DESC_LINE2}</p>
                </div>
              <div className="company-reg-btn">
                <Button title={Globals.LOGIN.REGISTER} id="register" action={navigateToCompanyRegistration} />
              </div>

            </div>
            <div className="frameChild" />
            <div className="registerAsACompanyParent producer-description">
              <div className="registerAsA">{Globals.SIGNUP.INDIVIDUAL}</div>
              <div className="thisOptionIs">
                <p className="description">{Globals.SIGNUP.INDIVIDUAL_DESC_LINE1}</p><br/>
                <p className="description">{Globals.SIGNUP.INDIVIDUAL_DESC_LINE2}</p>
                </div>
              <div></div>
              <div className="producer-reg-btn">
                <Button title={Globals.LOGIN.REGISTER} id="register" action={navigateToProducerRegistration} additionalStyle="register-btn" />
              </div>
            </div>
            <div className="signup-query-email">
            <span className="signup-query-email-string">{Globals.EMAIL_QUERY_STRING}</span><b className="signup-query-email-txt">{Globals.EMAIL_QUERY}</b>
            </div>
          </div>
        </div>
        <div className="signup-footer">
          <Footer />
        </div>
      </div>
    </>);
};

export default Signup;
